import { render, staticRenderFns } from "./AboutThree.vue?vue&type=template&id=a3ac6a5e&scoped=true&"
import script from "./AboutThree.vue?vue&type=script&lang=js&"
export * from "./AboutThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ac6a5e",
  null
  
)

export default component.exports